export default __webpack_public_path__ + "static/media/emptyState.386192a0.png";